export const update = {
  updateSuccessfully: '洗濯方法の更新に成功しました！',
}
